// hooks/travelPlan/reducer.js
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_PLANS: 'SET_PLANS',
    SET_SELECTED_PLAN: 'SET_SELECTED_PLAN',
    ADD_PLAN: 'ADD_PLAN',
    UPDATE_PLAN: 'UPDATE_PLAN',
    DELETE_PLAN: 'DELETE_PLAN',
    SET_PLAN_STATUS: 'SET_PLAN_STATUS',
    ADD_PLAN_COMMENT: 'ADD_PLAN_COMMENT',
    UPDATE_PLAN_APPROVER: 'UPDATE_PLAN_APPROVER',
    UPDATE_ATTACHMENTS: 'UPDATE_ATTACHMENTS',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE',
    UPDATE_ITINERARY: 'UPDATE_ITINERARY',
    UPDATE_BUDGET: 'UPDATE_BUDGET',
    UPDATE_PARTICIPANTS: 'UPDATE_PARTICIPANTS'
};

export const initialState = {
    plans: [],
    selectedPlan: null,
    loading: false,
    error: null,
    lastUpdated: null,
    filter: {
        status: null,
        planType: null,
        dateRange: {
            start: null,
            end: null
        },
        destination: null,
        organizer: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'createdAt',
        direction: 'desc'
    },
    cache: {}
};

export const travelPlansReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_PLANS:
            return {
                ...state,
                plans: action.payload.content || action.payload,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || action.payload.length,
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_PLAN:
            return {
                ...state,
                selectedPlan: action.payload,
                loading: false
            };

        case ACTIONS.ADD_PLAN:
            return {
                ...state,
                plans: [action.payload, ...state.plans],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_PLAN:
            return {
                ...state,
                plans: state.plans.map((plan) => (plan.id === action.payload.id ? action.payload.data : plan)),
                selectedPlan: state.selectedPlan?.id === action.payload.id ? action.payload.data : state.selectedPlan,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_PLAN:
            return {
                ...state,
                plans: state.plans.filter((plan) => plan.id !== action.payload),
                selectedPlan: state.selectedPlan?.id === action.payload ? null : state.selectedPlan,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_PLAN_STATUS:
            return {
                ...state,
                plans: state.plans.map((plan) => (plan.id === action.payload.id ? { ...plan, status: action.payload.status } : plan)),
                selectedPlan:
                    state.selectedPlan?.id === action.payload.id
                        ? { ...state.selectedPlan, status: action.payload.status }
                        : state.selectedPlan,
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.ADD_PLAN_COMMENT:
            return {
                ...state,
                selectedPlan: state.selectedPlan && {
                    ...state.selectedPlan,
                    comments: [...(state.selectedPlan.comments || []), action.payload]
                },
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.UPDATE_PLAN_APPROVER:
            return {
                ...state,
                selectedPlan: state.selectedPlan && {
                    ...state.selectedPlan,
                    approvers: state.selectedPlan.approvers.map((approver) =>
                        approver.approverId === action.payload.approverId ? { ...approver, ...action.payload } : approver
                    )
                },
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.UPDATE_ATTACHMENTS:
            return {
                ...state,
                selectedPlan: state.selectedPlan && {
                    ...state.selectedPlan,
                    attachments: action.payload
                },
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.UPDATE_ITINERARY:
            return {
                ...state,
                selectedPlan: state.selectedPlan && {
                    ...state.selectedPlan,
                    itinerary: action.payload
                },
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.UPDATE_BUDGET:
            return {
                ...state,
                selectedPlan: state.selectedPlan && {
                    ...state.selectedPlan,
                    budget: {
                        ...state.selectedPlan.budget,
                        ...action.payload
                    }
                },
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.UPDATE_PARTICIPANTS:
            return {
                ...state,
                selectedPlan: state.selectedPlan && {
                    ...state.selectedPlan,
                    participants: action.payload
                },
                lastUpdated: new Date().toISOString()
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0 // Reset to first page when filter changes
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
